/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from './pages/LandingPage';
import ScrollToTop from './components/ScrollToTop';
import { CookieBanner } from './components/CookieBanner';

// LandingPage stays eager — it's the / route and the LCP element. Everything
// else is split into its own chunk so the initial bundle for / is as small
// as possible. Each lazy route is fetched on first navigation to it.
const Home = lazy(() => import('./pages/Home'));
const SecurityReport = lazy(() => import('./pages/SecurityReport'));
const Ydelser = lazy(() => import('./pages/Ydelser'));
const Beredskab = lazy(() => import('./pages/Beredskab'));
const Compliance = lazy(() => import('./pages/Compliance'));
const OmOs = lazy(() => import('./pages/OmOs'));
const Kontakt = lazy(() => import('./pages/Kontakt'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Privatlivspolitik = lazy(() => import('./pages/Privatlivspolitik'));
const CookiePolitik = lazy(() => import('./pages/CookiePolitik'));

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <main>
          <Suspense fallback={<div className="min-h-screen bg-charcoal" />}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/security" element={<Home />} />
              <Route path="/security-report" element={<SecurityReport />} />
              <Route path="/ydelser" element={<Ydelser />} />
              <Route path="/beredskab" element={<Beredskab />} />
              <Route path="/compliance" element={<Compliance />} />
              <Route path="/om-os" element={<OmOs />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privatlivspolitik" element={<Privatlivspolitik />} />
              <Route path="/cookie-politik" element={<CookiePolitik />} />
            </Routes>
          </Suspense>
        </main>
        <CookieBanner />
      </Router>
    </HelmetProvider>
  );
}
